"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_dom_1 = __importDefault(require("react-dom"));
/**
 * These interfaces have been derived from the Web UI Component API:
 * https://woki.orionhealth.global/display/OHP/Web+UI+Component+Core+API+Component+Development+Summary
 */
var WebComponentAPI;
(function (WebComponentAPI) {
    class WebUIComponent {
        constructor(props) {
            this.props = props;
        }
        destroy() {
            this.props.container &&
                react_dom_1.default.unmountComponentAtNode(this.props.container);
        }
    }
    WebComponentAPI.WebUIComponent = WebUIComponent;
})(WebComponentAPI = exports.WebComponentAPI || (exports.WebComponentAPI = {}));
//# sourceMappingURL=WebComponentAPI.js.map